import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function SetupPassword() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    
    const email = searchParams.get('email');
    const token = searchParams.get('token');

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        try {
            // 1. Set the permanent password on the backend (unified route)
            const response = await fetch('/api/set-permanent-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, token, newPassword })
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.error || "Failed to set password.");
            }

            // 2. Automatically log the user in right after saving the password
            const loginResponse = await fetch('/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password: newPassword })
            });

            const loginData = await loginResponse.json();
            if (!loginResponse.ok) {
                throw new Error("Password saved, but automated login failed. Please log in manually.");
            }

            // 3. Store session credentials in localStorage based on role
            localStorage.setItem('userRole', loginData.role);
            localStorage.setItem('userId', loginData.id);

            if (loginData.role === 'instructor') {
                localStorage.setItem('instructorId', loginData.id);
            } else if (loginData.role === 'learner') {
                localStorage.setItem('learnerId', loginData.id);
                localStorage.setItem('userName', loginData.name);
                localStorage.setItem('instructorId', loginData.instructor_id);
                localStorage.setItem('forceOnboarding', 'true');
            }

            setSuccess(true);

            // 4. Redirect to the correct dashboard after a brief moment
            setTimeout(() => {
                if (loginData.role === 'instructor') {
                    navigate('/instructor-dash');
                } else {
                    navigate(`/learner-dash/${loginData.instructor_id || 5}`);
                }
            }, 1500);

        } catch (err) {
            setError(err.message || "Failed to complete setup. Link may be invalid or expired.");
        }
    };

    if (success) {
        return (
            <div style={{ textAlign: 'center', padding: '30px 20px', maxWidth: '400px', width: '92%', boxSizing: 'border-box', margin: '40px auto', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                <h2 style={{ color: '#16a34a' }}>🎉 Success! Logging you in...</h2>
                <p style={{ color: '#64748b' }}>Taking you straight to your dashboard.</p>
            </div>
        );
    }

    return (
        <div style={{ padding: '30px 20px', maxWidth: '400px', width: '92%', boxSizing: 'border-box', margin: '40px auto', background: '#ffffff', borderRadius: '12px', border: '1px solid #cbd5e0', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
            <h2 style={{ color: '#111', marginBottom: '10px', fontSize: '1.4rem' }}>Set Your Permanent Password</h2>
            <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '20px' }}>Please choose a secure password for your account.</p>
            
            {error && <p style={{ color: '#e53e3e', fontSize: '13px', marginBottom: '15px' }}>{error}</p>}
            
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px', width: '100%', boxSizing: 'border-box' }}>
                <input 
                    type="password" 
                    placeholder="New Password" 
                    value={newPassword}
                    autoComplete="new-password"
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    style={{ padding: '12px', border: '1px solid #cbd5e0', borderRadius: '6px', fontSize: '15px', width: '100%', boxSizing: 'border-box' }}
                />
                <input 
                    type="password" 
                    placeholder="Confirm New Password" 
                    value={confirmPassword}
                    autoComplete="new-password"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    style={{ padding: '12px', border: '1px solid #cbd5e0', borderRadius: '6px', fontSize: '15px', width: '100%', boxSizing: 'border-box' }}
                />
                <button type="submit" style={{ padding: '12px', background: '#0066cc', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', width: '100%', boxSizing: 'border-box' }}>
                    Save Password & Enter Dashboard
                </button>
            </form>
        </div>
    );
}